// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_components.js'; import './autoload/_vendors.js'

// Import everything from modules
//import './modules/announcement-swiper.js'; import './modules/components'; import './modules/components/_banner.js'; import './modules/components/_blog-swiper.js'; import './modules/components/_card-carousel.js'; import './modules/components/_ferry-banner.js'; import './modules/components/_ferry-single-banner.js'; import './modules/components/_grid-swiper.js'; import './modules/components/_header.js'; import './modules/components/_portfolio-tag.js'; import './modules/components/_scc-terminal-scrollbar.js'; import './modules/components/_smooth-scroll.js'; import './modules/components/_tenant-detail.js'; import './modules/components/_tenant-swiper.js'; import './modules/forms'; import './modules/forms/form.js'; import './modules/forms/inquiry.js'; import './modules/home.swiper.js'; import './modules/map.js'; import './modules/same_sized_cards.js'; import './modules/scrollable-swiper.js'; import './modules/termina-routes.js'; import './modules/terminal.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
// import jQuery from './routes/jquery.min';
import home from './routes/home';
import aboutUs from './routes/about';
import Utils from './util/utils';
import ENV from './env';


/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,

});

// Load Events
jQuery(document).ready(() => {

    Utils.init();
    setTimeout(() => {
        routes.loadEvents();
        Utils.showLoader(false);
    }, ENV.DELAY_INIT);

});


// WEBPACK FOOTER //
// ./scripts/main.js